// Dependencies
import { graphql, useStaticQuery } from 'gatsby';

const useHeaderMenu = () => {
  const { menu } = useStaticQuery(graphql`
    query HeaderMenu {
      menu: wpMenu(locations: { eq: HEADER_MENU }) {
        id
        menuItems {
          nodes {
            id
            label
            url
          }
        }
      }
    }
  `);

  return menu;
};

export default useHeaderMenu;
